import React from "react";

const ProgressBar = ({ progress, fillerColor, backgroundColor }) => {
  return (
    <div
      style={{
        width: "100%",
        height: "10px",
        backgroundColor: backgroundColor || "#EEE", // default light background
        overflow: "hidden",
      }}
    >
      <div
        style={{
          height: "100%",
          width: `${progress}%`,
          backgroundColor: fillerColor || "#4caf50", // default filler color
          borderRadius: "0 5px 5px 0",
          transition: "width 0.4s ease-in-out",
        }}
      ></div>
    </div>
  );
};

export default ProgressBar;
